import { useState, createContext, useEffect } from "react";
import getConfig from "next/config";
import axios from "axios";

type DrupalContextProps = {
	locale: string;
	isLoggedIn: boolean;
	username: string | null;
	requestStatusMessageArray: string;
};

export const DrupalContext = createContext<DrupalContextProps>({
	locale: "en",
	isLoggedIn: false,
	username: null,
	requestStatusMessageArray: "",
});

export const DrupalProvider = ({ locale, children }: any) => {
	const { subdir } = getConfig().publicRuntimeConfig;
	const { publicRuntimeConfig } = getConfig();
	const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
	const [username, setUsername] = useState<string>("");
	const [requestStatusMessageArray, setRequestStatusMessageArray] = useState<any>(false);

	useEffect(() => {
		// Verify BE user session
		axios
			.get(
				`${process.env.NEXT_PUBLIC_LOCAL_BASE || ""}/${subdir}/${locale ? locale : "en"}/api/session-verification`,
				{},
			)
			.then(res => {
				if (res?.data?.user?.id && res.data.user.id != 0) {
					setIsLoggedIn(true);
					setUsername(res.data.user.name || "");
				} else {
					setIsLoggedIn(false);
					setUsername("");
				}
			})
			.catch(e => console.log("e", e));
	}, []);

	useEffect(() => {
		axios
			.get(
				`${process.env.NEXT_PUBLIC_LOCAL_BASE || ""}/${publicRuntimeConfig.subdir}/${
					locale ? locale : "en"
				}/api/status-messages`,
				{},
			)
			.then(res => {
				if (res) setRequestStatusMessageArray(res?.data);
			})
			.catch(e => console.log("e", e));
	}, []);

	return (
		<DrupalContext.Provider value={{ locale, isLoggedIn, username, requestStatusMessageArray }}>
			{children}
		</DrupalContext.Provider>
	);
};
